import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Modal } from "components/Modal";
import { Table } from "components/Table";
import { columns } from "shared/StrategyOverview/v2/Components/Tables/RecentTransactions/columns";
import { useAuthorOrderHistory } from "features/Strategy/hook";
import { getStockCompanyIcon } from "utils/index";
import { TRADE_SIDE } from "utils/constants";
import { TransactionsSection } from "./AllTransactionsModal.styles";

const AllTransactionsModal = ({ isOpen, onClose, strategyId }) => {
  const {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    totalPages,
    totalCount,
    currentPage,
  } = useAuthorOrderHistory(strategyId, { enabled: isOpen });

  const transactions = useMemo(() => {
    if (!data?.pages?.length) return [];

    return data.pages.flatMap(
      (page) =>
        page.data?.map((item) => {
          const BUY = TRADE_SIDE.BUY.toUpperCase();
          return {
            ...item,
            id: item.order_id,
            asset: {
              symbol: item.universal_symbol?.symbol || "--",
              name: item.universal_symbol?.symbol || "--",
              imageUrl: getStockCompanyIcon(item.universal_symbol?.symbol),
            },
            type: item.action === BUY ? "Buy" : "Sell",
            executionPrice: item.execution_price || 0,
            shares: item.filled_quantity ?? item.quantity ?? 0,
            total:
              item.action === BUY
                ? Math.abs(item.total || 0)
                : -Math.abs(item.total || 0),
            date: item.date || "N/A",
          };
        }) || []
    );
  }, [data]);

  const handlePageChange = (newPage) => {
    if (!isFetchingNextPage && newPage > currentPage && hasNextPage) {
      fetchNextPage();
    }
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      size="lg"
      heading="Recent transactions"
    >
      <TransactionsSection>
        <Table
          data={transactions}
          columns={columns}
          isLoading={isLoading && transactions.length === 0}
          isSubLoading={isFetchingNextPage}
          showPagination={false}
          showEntriesText={false}
          notFoundText="No transactions found"
          customPagination
          handlePageChange={handlePageChange}
          totalPages={totalPages}
          totalRecords={totalCount}
        />
      </TransactionsSection>
    </Modal>
  );
};

AllTransactionsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  strategyId: PropTypes.string,
};

export default AllTransactionsModal;
